import { FC } from 'react';
import { TextLink } from '../components/shared/TextLink';
import { TERMINOS_Y_CONDICIONES, TERMINOS_Y_CONDICIONES_URL } from '../constants/data';

export const Terms: FC = () => {
  return (
    <div>
      He leído y acepto los &nbsp;
      <TextLink href={TERMINOS_Y_CONDICIONES_URL} children={TERMINOS_Y_CONDICIONES} />
    </div>
  );
};
